import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { HelperFunctions } from "@curbnturf/entities";
import { IPhoto } from "@curbnturf/objects";
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'curbnturf-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss'],
  standalone: true,
  imports: [IonicModule, NgIf],
})
export class DeleteModalComponent {
  @Input() photo: IPhoto;
  @Input() name: string;
  @Input() deleteFunction: () => void;
  @Input() closeFunction: () => void;

  getPhotoUrl(photo: IPhoto) {
    return HelperFunctions.getPhotoUrlFlatSmall(photo);
  }
}
